import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../helpers/api";
import { BASE_API } from "../../../../helpers/apiUrl";
import { toast } from "../../../../helpers/toast";
import {
  CommonOthers,
  ErrorMessage,
  GetAllUsersData,
  GetAllUsersParams,
  GetUsersCountParams,
  Params,
  PostRequest,
  UserData,
  UserUpdatePasswordData,
} from "../../../../types/redux";

// create a user
export const createUserAsync = createAsyncThunk<
  null,
  PostRequest<UserData, CommonOthers>
>(
  "np-resource/createUser",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.post(BASE_API.createUser, data);
      let successMsg = "PG created successfully";
      switch (data?.role) {
        case "vendor":
          successMsg = "Vendor created successfully";
          break;
        case "region":
          successMsg = "Regional admin created successfully";
          break;
        case "finance":
          successMsg = "Finance created successfully";
          break;
      }
      reRender(true);
      toast("success", successMsg);
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "Regional admin created fail");
      return rejectWithValue(error);
    }
  }
);

// get all users
export const getAllUsersAsync = createAsyncThunk<
  GetAllUsersData[],
  Params<GetAllUsersParams>,
  {
    rejectValue: ErrorMessage;
  }
>("np-resource/getAllUsers", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(BASE_API.getAllUsers, {
      params,
    });

    return data.data?.getData as GetAllUsersData[];
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    toast("error", error?.message || "Get all users fail");
    return rejectWithValue(error);
  }
});

// get count all users
export const getCountUsersAsync = createAsyncThunk<
  any,
  Params<GetUsersCountParams>,
  {
    rejectValue: ErrorMessage;
  }
>("np-resource/getCountUsers", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(BASE_API.getCountUsers, {
      params,
    });
    return data.data?.getData || 0;
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    toast("error", error?.message || "Get user count data fail");
    return rejectWithValue(error);
  }
});

// User Update Password
export const userUpdatePasswordAsync = createAsyncThunk<
  null,
  PostRequest<UserUpdatePasswordData, CommonOthers>
>(
  "np-supplier/userUpdatePassword",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.userUpdatePassword}`, data);
      reRender(true);
      toast("success", "User password updated successfully!");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "User password updated fail");
      return rejectWithValue(error);
    }
  }
);
